import { render } from "./CollezioniView.vue?vue&type=template&id=ef18d6c2&scoped=true"
import script from "./CollezioniView.vue?vue&type=script&lang=js"
export * from "./CollezioniView.vue?vue&type=script&lang=js"

import "./CollezioniView.vue?vue&type=style&index=0&id=ef18d6c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef18d6c2"]])

export default __exports__